<template>
  <div v-if="showModal" class="side__modal opened" id="modal__adding__customers">
    <div class="">
      <div class="side__modal__content">
        <div class="modal__top">
          <div class="modal__header">
            <h3 class="modal__title">{{ $lang.app.DOWNLOAD }}</h3>
            <span class="modal__close" @click="closeModal">
            <svg viewBox="0 0 20 20" width="20" height="20"><use xlink:href="@/assets/v2/img/sprite.svg#modal__close"></use></svg>
          </span>
          </div>
        </div>

        <Form class="modal__footer"
              @submit="submit">
          <div class="input__group input__checkbox">
            <input type="checkbox"
                   v-model="allSelected"
                   @click="selectAll"
                   id="all-input"
                   class="checkbox"
                   :value="true">
            <label for="all-input" class="label">{{ $lang.app.ALL }}</label>
          </div>
          <div v-for="(section, key) in this.helper.sectionOptions" :key="key"
               class="input__group input__checkbox">
            <div>
              <div class="flex items-center">
                <input v-model="sectionIds"
                       @click="select"
                       :value="section.value"
                       type="checkbox"
                       :id="`section-${key}-input`"
                       class="checkbox">
                <label :for="`section-${key}-input`" class="label">{{ section.label }}</label>
              </div>
            </div>
          </div>
          <div class="between__buttons">
            <button type="button" class="button button__modal__close button--cancel" @click="closeModal">{{ $lang.app.CANCEL }}</button>
            <button type="submit" class="relative button button__modal__close"
                    :disabled="submitting">
              {{ $lang.app.DOWNLOAD }}
              <div v-if="submitting" class="loading-blue text-white absolute z-10 w-full rounded-lg h-full top-0 left-0 flex items-center justify-center">
                <div class="block animate-spin">
                  <RefreshIcon class="w-6 h-6 mirror-y"/>
                </div>
              </div>
            </button>
          </div>
        </Form>
      </div>
    </div>
  </div>

</template>
<script>
import {Form} from 'vee-validate'
import applicationApi from "../../../../api/employee/application";

export default {
  props: {
    application: Object
  },
  components: {
    Form
  },
  data() {
    return {
      showModal: false,
      submitting: false,

      selected: [],
      allSelected: false,
      sectionIds: [],
      helper: {
        sectionOptions: [],
      },
    };
  },
  methods: {
    openModal() {
      this.showModal = true
      this.$emitter.emit('body-unscrollable')
    },
    closeModal() {
      this.showModal = false
      this.$emitter.emit('body-scrollable')
    },
    initSectionOptions() {
      applicationApi.getSectionOptions(this.application.id).then(res => {
        this.helper.sectionOptions = res.data?.map(item => ({
          value: item.id,
          label: item.sectionName,
        }))
      })
    },
    submit() {
      this.submitting = true
      if (this.allSelected) {
        applicationApi
            .downloadAllSectionFiles(this.application.id)
            .then((res) => {
                  var FILE = window.URL.createObjectURL(new Blob([res.data]));
                  var docUrl = document.createElement('a');
                  docUrl.href = FILE;
                  docUrl.setAttribute('download', this.application.name +'.zip');
                  document.body.appendChild(docUrl);
                  docUrl.click();
                  docUrl.remove();

                  this.closeModal()
                }
            )
            .catch((error) => {
              this.$snotify.error(error);
            })
            .finally(() => {
              this.submitting = false
            })
      } else {
        this.selected = this.sectionIds.map((val) => {
          return {document: val}
        })
        applicationApi
            .downloadSelectSectionFiles(this.application.id, {sections: this.selected})
            .then((res) => {
                  var FILE = window.URL.createObjectURL(new Blob([res.data]));
                  var docUrl = document.createElement('a');
                  docUrl.href = FILE;
                  docUrl.setAttribute('download', this.application.name +'.zip');
                  document.body.appendChild(docUrl);
                  docUrl.click();
                  docUrl.remove();

                  this.closeModal()
                }
            )
            .catch((error) => {
              this.$snotify.error(error);
            })
            .finally(() => {
              this.submitting = false
            })
      }

    },
    selectAll() {
      this.sectionIds = [];
      if (!this.allSelected) {
        this.helper.sectionOptions.forEach((item) => {
          this.sectionIds.push(item.value);
        })
      }
    },
    select: function () {
      this.allSelected = false;
    }
  },
  beforeMount() {
    this.$emitter.on('open-application-download-modal', () => {
      this.openModal()
      this.initSectionOptions()
    })
  },
  beforeUnmount() {
    this.$emitter.off('open-application-download-modal')
  },
}
</script>
